import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";

Vue.use(Router);

let frontRoutes = [
  {
    path: "/index",
    name: "Index",
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/Index.vue"),
  },
  {
    path: "/index/rec-teacher",
    name: "IndexRecommendTeacher",
    component: () =>
      import(/* webpackChunkName: "common" */ "../views/ShowTeachers.vue"),
  },
  {
    path: "/searchResult",
    name: "SearchResult",
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/SearchResult.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "common" */ "../views/About.vue"),
  },
  {
    path: "/show-teachers",
    name: "ShowTeachers",
    component: () =>
      import(/* webpackChunkName: "common" */ "../views/ShowTeachers.vue"),
  },
  {
    path: "/show-teachers/showTeachersDetaial/:id",
    name: "ShowTeachersDetaial",
    component: () =>
      import(
        /* webpackChunkName: "common" */ "../views/oto/OtoTeacherShow.vue"
      ),
  },
  {
    path: "/show-teachers/adminIndex",
    name: "TeacherAdminIndex",
    component: () => import("../views/TeacherAdminIndex.vue"),
  },
  {
    path: "/inviteTeacher",
    name: "ShowAppointmentTeachers",
    component: () =>
      import(
        /* webpackChunkName: "common" */ "../views/ShowAppointmentTeachers.vue"
      ),
  },
  // {
  //   path: "/vip",
  //   name: "MemberVip",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "member" */
  //       "../views/member/MemberVip.vue"
  //     ),
  // },
  {
    path: "/contact",
    name: "ContactUs",
    component: () =>
      import(/* webpackChunkName: "common" */ "../views/ContactUs.vue"),
  },
  {
    path: "/help",
    name: "HelpCenter",
    component: () =>
      import(/* webpackChunkName: "common" */ "../views/HelpCenter.vue"),
  },
  {
    path: "/integral/goods/:id",
    name: "IntegralGoodsDetail",
    component: () =>
      import(
        /* webpackChunkName: "integral" */
        "../views/integral/IntegralGoodsDetail.vue"
      ),
  },
];

let memberRoutes = [
  {
    path: "/member/address",
    name: "MemberAddress",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/MemberAddress.vue"
      ),
    meta: {
      requireAuth: true,
      title: "收货地址",
      root: true,
    },
  },
  {
    path: "/member/profile",
    name: "MemberProfile",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/MemberProfile.vue"
      ),
    meta: {
      requireAuth: true,
      title: "个人设置",
      root: true,
    },
  },
  {
    path: "/member/wealth",
    name: "MemberWealth",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/MemberWealth.vue"
      ),
    meta: {
      requireAuth: true,
      title: "我的财富",
      root: true,
    },
  },
  {
    path: "/member/myConsultation",
    name: "MemberMyConsultation",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/MemberMyConsultation.vue"
      ),
    meta: {
      requireAuth: true,
      title: "我的咨询",
      root: true,
    },
  },
  {
    path: "/member/message",
    name: "MemberMessage",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/MemberMessage.vue"
      ),
    meta: {
      requireAuth: true,
      title: "消息中心",
      root: true,
    },
  },
  {
    path: "/member/integral",
    name: "MemberIntegral",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/integral/MemberIntegral.vue"
      ),
    meta: {
      requireAuth: true,
      title: "我的积分",
      root: true,
    },
  },
  {
    path: "/member/clockin",
    name: "MemberClockin",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/MemberClockin.vue"
      ),
    meta: {
      requireAuth: true,
      title: "我的打卡",
      root: true,
    },
  },
  {
    path: "/member/cert",
    name: "MemberCert",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/MemberCert.vue"
      ),
    meta: {
      requireAuth: true,
      title: "我的证书",
      root: true,
    },
  },
  {
    path: "/member/ebook",
    name: "MemberEbooks",
    component: () =>
      import(
        /* webpackChunkName: "member" */
        "../views/member/MemberEbooks.vue"
      ),
    meta: {
      requireAuth: true,
      title: "我的电子书",
      root: true,
    },
  },
];

(function () {
  let files = require.context(".", false, /.js$/);
  let keys = files.keys();
  keys.forEach(key => {
    if (key.indexOf("index.js") > 0) {
      return;
    }
    let router = files(key).default;
    if (router.frontRoutes) {
      frontRoutes = frontRoutes.concat(router.frontRoutes);
    }
    if (router.memberRoutes) {
      memberRoutes = memberRoutes.concat(router.memberRoutes);
    }
  });
})();

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/ebooks/reader/:id",
      name: "EbooksReader",
      component: () =>
        import(
          /* webpackChunkName: "book" */ "../views/ebooks/EbooksReader.vue"
        ),
    },
    {
      path: "/",
      name: "Home",
      redirect: "/index",
      component: Home,
      children: frontRoutes,
    },
    {
      path: "/member",
      name: "Member",
      component: () =>
        import(/* webpackChunkName: "member" */ "../views/member/Member.vue"),
      meta: {
        requireAuth: true,
      },
      children: memberRoutes,
    },
    {
      path: "/download",
      name: "Download",
      component: () =>
        import(/* webpackChunkName: "download" */ "../views/Download.vue"),
    },
    {
      path: "/download-client",
      name: "DownloadClient",
      component: () =>
        import(
          /* webpackChunkName: "download-client" */ "@/components/DownloadClient"
        ),
      meta: {
        title: "直播客户端",
      },
    },
    {
      path: "/video",
      name: "Video",
      component: () =>
        import(/* webpackChunkName: "course" */ "../views/course/Video.vue"),
    },
    {
      path: "/login",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    },
    {
      path: "/contract",
      name: "Contract",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Contract.vue"),
    },
    {
      path: "/live",
      name: "Live",
      component: () =>
        import(/* webpackChunkName: "live" */ "../views/Live.vue"),
    },
    {
      path: "/regist-information",
      name: "RegistInformation",
      component: () =>
        import(
          /* webpackChunkName: "regist-information" */ "../views/RegistInformation.vue"
        ),
    },
    {
      path: "/custom/:id",
      name: "CustomPage",
      component: () =>
        import(/* webpackChunkName: "custom-page" */ "../views/CustomPage.vue"),
    },
  ],
});
